// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"1de50541","138":"e2e89617","270":"dd666a81","289":"e2052568","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"8108ed40","686":"a5ada013","706":"44ba4c26","728":"676c889f","801":"39e48a2b"}[chunkId] + ".chunk.js";
};